import * as React from 'react';

import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { ListingGallery } from './listing-gallery';
import { RenderGalleryProps } from './title';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';
import { TitleImage } from './title-image';

export const TitleGallery: React.FunctionComponent<RenderGalleryProps> = ({ lazyLoadImg, listingGalleryProps, renderImageProps }) => {
  const imageUrl = renderImageProps.imageUrl;

  return (
    <UitkLayoutFlexItem grow={1}>
      {lazyLoadImg && (
        <SimpleLazyLoadWrapper
          key={`lazy-${imageUrl}`}
          loadOffset={{ top: 350, bottom: 350 }}
          placeholder={<TitleImage renderImg={renderImageProps} serverRender={true} />}
        >
          <ListingGallery {...listingGalleryProps} />
        </SimpleLazyLoadWrapper>
      )}
      {!lazyLoadImg && <ListingGallery {...listingGalleryProps} />}
    </UitkLayoutFlexItem>
  );
};
TitleGallery.displayName = 'TitleGallery';
